// extracted by mini-css-extract-plugin
export default {"sticker":"StickerWithTabButton_sticker__s0VP-","sticker-top":"StickerWithTabButton_sticker-top__eIpVo","title":"StickerWithTabButton_title__MkPZQ"};